import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";
import type { components } from "@/types/api/api-types";

type StatementDraftBody = components["schemas"]["CreateStatementDto"];

/** Update an existing draft (owner + status=draft only, enforced server-side). */
export const useUpdateStatementDraft = () =>
  useMutation({
    mutationFn: async ({
      params,
      body,
    }: {
      params: { path: { id: string } };
      body: StatementDraftBody;
    }) => {
      const { data, error } = await (
        fetchClient as unknown as {
          PATCH: (
            path: "/statements/drafts/{id}",
            init: {
              params: { path: { id: string } };
              body: StatementDraftBody;
            },
          ) => Promise<{ data?: unknown; error?: unknown }>;
        }
      ).PATCH("/statements/drafts/{id}", { params, body });
      if (error) throw error;
      return data;
    },
  });
